
import {
  Component, Ref, Mixins, InjectReactive, Watch,
} from 'vue-property-decorator';
import Verification from '@/features/shipment/components/checkout/Verification.vue';
import { VForm } from '@/features/common/types';
import { confirmVerificationAmount } from '@/features/shipment/services/shipment.services';
import { AvailableService, PaymentInfoResponse } from '@/features/shipment/types';
import { CheckoutCreateLabelMixin } from '@/features/shipment/components/checkout/mixins';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { scrollToInPage } from '@/features/common/helpers';
import { UserInfo } from '@/features/users/types';

@Component({
  components: {
    Verification,
  },
})
export default class Verify extends Mixins(CheckoutCreateLabelMixin) {
  @InjectReactive() readonly existingCardInfo!: PaymentInfoResponse | null;

  @Ref('form') form!: VForm;

  private verificationAmount: string | null = null;

  private attemptsCount = 0;

  private isLoading = false;

  get selectedService(): AvailableService | null {
    return this.$store.getters.getSelectedService;
  }

  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }

  @Watch('existingCardInfo', { immediate: true })
  private setAttemptsCount(existingInfo: PaymentInfoResponse | null) {
    if (!existingInfo) return;
    this.attemptsCount = existingInfo.attempts || 0;
  }

  // eslint-disable-next-line class-methods-use-this
  mounted(): void {
    scrollToInPage();
  }

  private async submit() {
    const isValid = this.form.validate();
    if (!isValid) return;

    if (!this.verificationAmount) return;

    this.isLoading = true;

    const verificationResponse = await confirmVerificationAmount(+this.verificationAmount);

    if (verificationResponse?.amountConfirmed) {
      await this.createLabelAndPrint();
      if (this.labelResponse?.errorType === 'CreditCardChallengeRequired' && this.labelResponse?.threeDsChallenge) {
        return;
      }
    } else {
      if (verificationResponse?.errorType === 'TooManyFailedAttemptsOnCard') {
        this.redirectUrl = '/shipment/checkout?reset=1';
      }
      this.showOopsDialog(verificationResponse?.errorMessage, false);
      this.attemptsCount += 1;
    }

    this.isLoading = false;
  }

  private hideVerificationPage = () => {
    eventBus.$emit(eventNames.HIDE_VERIFICATION_PAGE);
  }
}
